import * as React from "react";
const UploadImagePlaceholder = (props) => (
    <svg
        width={48}
        height={48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-grey90 dark:text-white/25"
        {...props}
    >
        <path
            d="M41.94 2h-5.88c-1.74 0-3.02.72-3.6 2-.32.58-.46 1.26-.46 2.06v5.88c0 2.54 1.52 4.06 4.06 4.06h5.88c.8 0 1.48-.14 2.06-.46 1.28-.58 2-1.86 2-3.6V6.06C46 3.52 44.48 2 41.94 2m1.88 7.86c-.2.2-.5.34-.82.36h-2.82v1.02L40.2 13c-.02.34-.14.62-.38.86-.2.2-.5.34-.82.34-.66 0-1.2-.54-1.2-1.2v-2.8l-2.8.02A1.22 1.22 0 0 1 33.8 9c0-.66.54-1.2 1.2-1.2l1.76.02h1.04v-2.8c0-.66.54-1.22 1.2-1.22s1.2.56 1.2 1.22l-.02 1.42V7.8H43c.66 0 1.2.54 1.2 1.2a1.36 1.36 0 0 1-.38.86M18.002 20.762a4.76 4.76 0 1 0 0-9.52 4.76 4.76 0 0 0 0 9.52"
            fill="currentColor"
        />
        <path
            d="M41.94 16H41v9.22l-.26-.22c-1.56-1.34-4.08-1.34-5.64 0l-8.32 7.14c-1.56 1.34-4.08 1.34-5.64 0l-.68-.56c-1.42-1.24-3.68-1.36-5.28-.28L7.7 36.32C7.26 35.2 7 33.9 7 32.38V15.62C7 9.98 9.98 7 15.62 7H32v-.94c0-.8.14-1.48.46-2.06H15.62C8.34 4 4 8.34 4 15.62v16.76c0 2.18.38 4.08 1.12 5.68 1.72 3.8 5.4 5.94 10.5 5.94h16.76C39.66 44 44 39.66 44 32.38V15.54c-.58.32-1.26.46-2.06.46"
            fill="currentColor"
        />
    </svg>
);
export default UploadImagePlaceholder;
